import React, { useEffect } from 'react';
import { googleMapsKey } from './utils/url';

const InjectScript: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&libraries=places,anyOtherLib`;
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      // Cleanup: remove the script when the component is unmounted
      document.body.removeChild(script);
    };
  }, []);

  return <></>;
};

export default InjectScript;
